import * as React from 'react';
import { Card, CardContent, CardActions, Button, Typography, Grid, CardActionArea } from '@mui/material';
import { styled } from '@mui/material/styles';

// Supposons que img_rubrique_sport est votre image importée
import img_rubrique_sport from '../images/rubriques/rubrique_sports.webp';
import img_rubrique_player from '../images/rubriques/rubrique_players.webp';

const CustomCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection : 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 200,
  padding: theme.spacing(2),
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

const ImageContainer = styled('div')({
  display: 'flex',
  marginRight: 16, // Adjust the space between image and text as needed
});

const rubriques = [
  { titre: 'Sports', description: 'Explorez tous les sports existants', lien: 'multisport/sports', backgroundImage: img_rubrique_player },
  { titre: 'Athlètes', description: 'Explorez tous les athlètes', lien: 'multisport/actors', backgroundImage: img_rubrique_player },
  { titre: 'Événements', description: 'Explorez les événements sportifs', lien: 'multisport/events', backgroundImage: img_rubrique_player },
  // Ajoutez plus de rubriques ici au besoin
];

function IndexMultiSport() {
    return (
      <Grid container spacing={2}>
        {rubriques.map((rubrique, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <CustomCard>
              <CardActionArea href={rubrique.lien} style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ImageContainer>
                    <img src={rubrique.backgroundImage} alt={rubrique.titre} style={{ width: 'auto', height: 80 }} />
                  </ImageContainer>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="div">
                      {rubrique.titre}
                    </Typography>
                    <Typography variant="body2">
                      {rubrique.description}
                    </Typography>
                  </CardContent>
                </div>
              </CardActionArea>
              {/*<CardActions sx={{ justifyContent: 'flex-end', padding: '16px' }}>
                <Button size="small" variant="contained" color="primary" onClick={(e) => {
                  e.stopPropagation(); // Prévenir le click de se propager au CardActionArea
                  window.location.href = rubrique.lienCreate; // Rediriger vers le lien 'Créer'
                }}>
                  Créer
                </Button>
              </CardActions>*/}
            </CustomCard>
          </Grid>
        ))}
      </Grid>
    );
}
  
export default IndexMultiSport;
